var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 42,
    viewBox: "0 0 32 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33368 11.0521C5.33368 4.95796 10.1191 0 16.001 0C21.883 0 26.6684 4.95796 26.6684 11.0521C26.6684 17.1462 21.883 22.1041 16.001 22.1041C10.1191 22.1041 5.33368 17.1462 5.33368 11.0521ZM24.7846 24.4716C23.5919 24.1577 22.2948 24.3346 21.2217 24.9535C17.9831 26.8191 14.019 26.8191 10.7804 24.9535C9.70939 24.3368 8.41014 24.1621 7.21753 24.4716C2.96765 25.5834 0 29.5798 0 34.1885V36.4232C0 37.8335 0.36265 39.2126 1.05176 40.415C1.61286 41.392 2.66474 42 3.79335 42H28.2067C29.3353 42 30.387 41.3943 30.9481 40.4129C31.6372 39.2126 32 37.8335 32 36.4232V34.1885C32.0021 29.5798 29.0344 25.5834 24.7846 24.4716Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFilled);
export default __webpack_public_path__ + "static/media/user-Filled.a9c0302b6ce9708e9c1b68e361bf7f1d.svg";
export { ForwardRef as ReactComponent };